/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.4",
    versionName: "0.2.0-nightly.2026.3.4",
    versionChannel: "nightly",
    buildDate: "2026-03-04T00:12:00.191Z",
    commitHash: "680f1f55417fe59fa15cbf28da55110f546fbd06",
};
